import { ERouteDisclaimerMessage } from '../enums';
import { ValidatorState } from '../types';
import { appIsActive } from '../utils';

export function discountsAndCuponsValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const isValid = appIsActive();

  if (!isValid) {
    disclaimersKeys.push(
      ERouteDisclaimerMessage.DISCOUNTS_AND_CUPONS_RESTRICTION
    );
  }

  return {
    isValid,
    disclaimersKeys
  };
}
